export default __webpack_public_path__ + "static/media/opensea_white.d90f4eb2.svg";